import { nhAppMainPages } from './nhAppMainPages';

interface RouteAccessRule {
  pathPrefix: string;
  restricted: boolean;
}

// Rules are matched by prefix. More specific (longer) prefixes take precedence.
// Routes NOT listed here are accessible to all authenticated users.
export const routeAccessRules: readonly RouteAccessRule[] = [
  // Admin/manager-only route groups
  { pathPrefix: nhAppMainPages.RECURRING_ITEMS_V2, restricted: true },
  { pathPrefix: nhAppMainPages.SERVICE_PROVIDER, restricted: true },
  { pathPrefix: nhAppMainPages.NURSING_HOME_ACCOUNTING, restricted: true },
  { pathPrefix: nhAppMainPages.NURSING_HOME, restricted: true },

  // Exceptions: sub-routes accessible to all (more specific prefix wins)
  {
    pathPrefix: nhAppMainPages.NURSING_HOME_ACCOUNTING_CARD_PAYMENTS,
    restricted: false,
  },
];

const matchesRoutePrefix = (pathname: string, prefix: string): boolean =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

export function isRouteAccessible(
  pathname: string,
  isAdminOrManager: boolean
): boolean {
  // Find all rules whose prefix matches the pathname, then pick the most
  // specific one (longest prefix). This lets sub-routes override parent rules,
  // e.g. /accounting/card-payments (unrestricted) overrides /accounting (restricted).
  const matchingRules = routeAccessRules
    .filter((rule) => matchesRoutePrefix(pathname, rule.pathPrefix))
    .sort((a, b) => b.pathPrefix.length - a.pathPrefix.length);

  if (matchingRules.length === 0) {
    return true; // no rule = open access
  }

  const rule = matchingRules[0]; // most specific match
  return !rule.restricted || isAdminOrManager;
}
